import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import { PanAppState } from '@panamax/app-state';
import { PATHS } from '@shared/constants/paths';
import { FEATURES } from '@shared/constants/splitio-features';
import { combineLatest, map, Observable } from 'rxjs';

export const newSearchRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const panAppState = inject(PanAppState);
  return combineLatest([
    panAppState.feature$([FEATURES.split_dynamic_new_search_enabled.name]),
    panAppState.feature$([FEATURES.split_dynamic_search_toggle_visible.name]),
  ]).pipe(
    map(([newSearchFeatureFlag, newSearchToggleFlag]) => {
      const urlSegments = route.url;
      const isSearchPath =
        urlSegments.length > 0 &&
        urlSegments[urlSegments.length - 1].path === 'search' &&
        (route.children.length === 0 || route.children[0].url.length === 0);

      if (isSearchPath && newSearchFeatureFlag && !newSearchToggleFlag) {
        return router.createUrlTree(['/' + PATHS.NEW_SEARCH], {
          queryParams: { searchText: route.queryParamMap.get('searchText') },
        });
      }
      return true;
    }),
  );
};
